import { TenantResponse } from "../../tenants/models/tenant.model";

export interface User {
    id: string;
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    role: string;
    userType: string;
}

export type UserRole = "ADMIN" | "HOST" | "PRODUCER" | "MARKETER";

export type UserType = "OKTA" | "EXTERNAL";

export interface RoleOption {
    value: UserRole;
    label: string;
}

export const ROLE_OPTIONS: readonly RoleOption[] = [
    { value: "PRODUCER", label: "Producer" },
    { value: "HOST", label: "Host" },
    { value: "ADMIN", label: "Admin" },
    { value: "MARKETER", label: "Marketing/Merchandising" }
];

export interface UserFormValue {
    userType: UserType;
    email: string;
    role: UserRole;
    tenantIds: string[];
    firstName?: string;
    lastName?: string;
}

export interface CreateUserRequest {
    email: string;
    userType: UserType;
    role: UserRole;
    tenantIds: string[];
    firstName?: string;
    lastName?: string;
}

export interface UserCreateResponse {
    sub: string;
    status: string;
}

export interface UserDetail {
    id: string | null;
    username: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    role: UserRole | null;
    userType: UserType;
    pending: boolean;
    tenants: TenantResponse[];
}

export interface UpdateUserRequest {
    role: UserRole;
    tenantIds: string[];
    firstName?: string;
    lastName?: string;
}
